// @ts-nocheck
import { InMemoryCache, makeVar, ReactiveVar } from '@apollo/client';
import { Company } from '../models/Company';
import { Template } from '../models/Template';

export const cache: InMemoryCache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        companies: {
          read() {
            return companiesVar();
          },
        },
        templates: {
          read() {
            return templatesVar();
          },
        },
      },
    },
  },
});

/**
 * Set initial values when we create cache variables.
 */

const companiesInitialValue: Company[] = [
  {
    id: '1',
    name: 'Walmart',
    templateId: null,
    status: null,
    updatedBy: null,
    investments: [
      {
        fundName: 'My Fund 1',
        investmentAmount: 1000000
      }
    ],
    sectors: [
      'Finance', 'SaaS',
    ],
  },
  {
    id: '2',
    name: 'Green Moon Corp',
    templateId: null,
    status: null,
    updatedBy: null,
    investments: [
      {
        fundName: 'My Fund 2',
        investmentAmount: 2000000
      }
    ],
    sectors: [
      'Finance', 'SaaS',
    ],
  },
  {
    id: '3',
    name: 'Mover Inc.',
    templateId: null,
    status: null,
    updatedBy: null,
    investments: [
      {
        fundName: 'My Fund 3',
        investmentAmount: 3000000
      }
    ],
    sectors: [
      'Finance', 'SaaS',
    ],
  },
  {
    id: '4',
    name: 'KeyPhonics',
    templateId: null,
    status: null,
    updatedBy: null,
    investments: [
      {
        fundName: 'My Fund 1',
        investmentAmount: 1000000
      }
    ],
    sectors: [
      'Finance', 'SaaS',
    ],
  },
  {
    id: '5',
    name: 'Ampsy',
    templateId: null,
    status: 'Draft Saved',
    updatedBy: 'Nicholas Yetti 08/12/20',
    investments: [
      {
        fundName: 'My Fund 2',
        investmentAmount: 2000000
      }
    ],
    sectors: [
      'Finance', 'SaaS',
    ],
  },
  {
    id: '6',
    name: 'Assurely',
    templateId: '1',
    status: 'Draft Saved',
    updatedBy: 'Global Admin 08/05/20',
    investments: [
      {
        fundName: 'My Fund 3',
        investmentAmount: 3000000
      }
    ],
    sectors: [
      'Finance', 'SaaS',
    ],
  },
  {
    id: '7',
    name: 'Bespoke Post',
    templateId: '1',
    status: 'Draft Saved',
    updatedBy: 'Global Admin 08/05/20',
    investments: [
      {
        fundName: 'My Fund 1',
        investmentAmount: 1000000
      }
    ],
    sectors: [
      'Finance', 'SaaS',
    ],
  },
  {
    id: '8',
    name: 'BetterThings',
    templateId: '1',
    status: 'Draft Saved',
    updatedBy: 'Global Admin 08/05/20',
    investments: [
      {
        fundName: 'My Fund 2',
        investmentAmount: 2000000
      }
    ],
    sectors: [
      'Finance', 'SaaS',
    ],
  },
  {
    id: '9',
    name: 'Black Book Access',
    templateId: '1',
    status: 'Draft Saved',
    updatedBy: 'Global Admin 08/05/20',
    investments: [
      {
        fundName: 'My Fund 3',
        investmentAmount: 3000000
      }
    ],
    sectors: [
      'Finance', 'SaaS',
    ],
  },
  {
    id: '10',
    name: 'Blue Cat Inc.',
    templateId: '1',
    status: 'Draft Saved',
    updatedBy: 'Global Admin 08/05/20',
    investments: [
      {
        fundName: 'My Fund 1',
        investmentAmount: 1000000
      }
    ],
    sectors: [
      'Finance', 'SaaS',
    ],
  },
  {
    id: '11',
    name: 'Blue Hat',
    templateId: '1',
    status: 'Draft Saved',
    updatedBy: 'Global Admin 08/05/20',
    investments: [
      {
        fundName: 'My Fund 2',
        investmentAmount: 2000000
      }
    ],
    sectors: [
      'Finance', 'SaaS',
    ],
  },
  {
    id: '12',
    name: 'Border City Media',
    templateId: '1',
    status: 'Draft Saved',
    updatedBy: 'Global Admin 08/05/20',
    investments: [
      {
        fundName: 'My Fund 3',
        investmentAmount: 3000000
      }
    ],
    sectors: [
      'Finance', 'SaaS',
    ],
  },
  {
    id: '13',
    name: 'Local Motors',
    templateId: '1',
    status: 'Draft Saved',
    updatedBy: 'Global Admin 08/05/20',
    investments: [
      {
        fundName: 'My Fund 1',
        investmentAmount: 1000000
      }
    ],
    sectors: [
      'Finance', 'SaaS',
    ],
  },
];


const templatesInitialValue: Template[] = [
  {
    id: '1',
    name: 'Core Investment',
    status: 'active',
  },
  {
    id: '2',
    name: 'SaaS',
    status: 'active',
  },
  {
    id: '3',
    name: 'EE Template II',
    status: 'active',
  },
];

export const companiesVar: ReactiveVar<Company[]> = makeVar<Company[]>(
  companiesInitialValue,
);

export const templatesVar: ReactiveVar<Template[]> = makeVar<Template[]>(
  templatesInitialValue,
);
